import { render, staticRenderFns } from "./MordaLentaBuy.vue?vue&type=template&id=4d2e2884"
import script from "./MordaLentaBuy.vue?vue&type=script&lang=js"
export * from "./MordaLentaBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports